export const projects = [
  {
    id: 0,
    name: "Ticket Store",
    src: "/environment/ticket-store.png",
    description:
      "Our application starts with the completion of a public application form by the end user. The user who fills out the form is given a code to track his application. The user can check whether his application has been resolved with this code from the application status page.",
    link: "https://ticketstore.netlify.app/",
    github:
      "https://github.com/159-Pazarama-React-Bootcamp/final-project-dexdere",
    tags: [
      "Html",
      "Css",
      "Javascript",
      "React",
      "Redux",
      "Formik",
      "Yup",
      "Mock Api",
      "React Router",
    ],
  },
  {
    id: 1,
    name: "Clone Project",
    src: "/environment/clone-project.png",
    description:
      "React clone of a design found in Figma. Click on github link or live link for details.",
    link: "https://cloneproject-patika.netlify.app/login",
    github:
      "https://github.com/159-Pazarama-React-Bootcamp/week-3-case-dexdere",
    tags: ["Html", "Css", "Javascript", "React", "Mock Api", "React Router"],
  },
  {
    id: 2,
    name: "Todo App",
    src: "/environment/todo-app-patika.png",
    description:
      "A todo app that allows you to add, delete, and edit your todos. You can also mark your todos as completed. Click on github link or live link for details.",
    link: "https://todoapp-patika.netlify.app/",
    github:
      "https://github.com/159-Pazarama-React-Bootcamp/week-2-case-dexdere",
    tags: ["Html", "Css", "Javascript", "Mock Api"],
  },
  {
    id: 3,
    name: "Check Credit Card",
    src: "/environment/check-credit-card.png",
    description:
      "A credit card checker that checks if a credit card number is valid or not. Click on github link or live link for details.",
    link: "https://checkcreditcard.netlify.app/",
    github:
      "https://github.com/159-Pazarama-React-Bootcamp/week-1-case-dexdere",
    tags: ["Html", "Css", "Javascript"],
  },
  {
    id: 4,
    name: "Trading Platform",
    src: "/environment/trading-platform.png",
    description:
      "A trading platform that allows you to buy and sell stocks. Click on github link or live link for details.",
    link: "https://eager-thompson-941ee4.netlify.app/exchange",
    github: "https://github.com/dexdere/trading-platform",
    tags: ["Html", "Css", "Javascript", "React", "Reactstrap", "WebSocket"],
  },
  {
    id: 5,
    name: "World of Feed",
    src: "/environment/world-of-feed2.png",
    description:
      "It's a Pinterest-like clone. Unsplash api was used. Click on github link or live link for details.",
    link: "https://pinterestclone-kodluyoruz.netlify.app/",
    github: "https://github.com/dexdere/kodluyoruz-pinterest-project",
    tags: ["Html", "Css", "Javascript", "React", "Axios", "Unsplash Api"],
  },
  {
    id: 6,
    name: "Realtime Color App",
    src: "/environment/realtime-color-app.png",
    description:
      "A realtime color app that allows you to change the color of the background. Click on github link or live link for details.",
    link: "https://realtimecolor.netlify.app",
    github: "https://github.com/dexdere/odev-4-realtime-colors-app-dexdere",
    tags: ["Html", "Css", "Javascript", "React", "Node.js", "WebSocket"],
  },
  {
    id: 7,
    name: "Weather App",
    src: "/environment/weather-app.png",
    description:
      "A weather app that allows you to see the weather of a city. Click on github link or live link for details.",
    link: "https://weatherapp-kodluyoruz.netlify.app/",
    github: "https://github.com/dexdere/odev-3-weather-app-dexdere",
    tags: ["Html", "Css", "Javascript", "React", "Weather Api"],
  },
  {
    id: 8,
    name: "Todo App",
    src: "/environment/todo-app-kodluyoruz.png",
    description:
      "A todo app that allows you to add, delete, and edit your todos. You can also mark your todos as completed. Click on github link or live link for details.",
    link: "https://todoapp-kodluyoruz.netlify.app",
    github: "https://github.com/dexdere/odev-2-todo-app-dexdere",
    tags: ["Javascript", "React"],
  },
];
